import { Injectable } from '@angular/core';
import { APP_CONFIG, Region } from '../../environment';
import { IdentityVerificationMapper } from './identity-verification-mapper';
import { IIdologyProgressResponseEntity } from '../../model/api/identity-verification/idology-progress-response.entity.interface';
import { IIdologyVerifyIdentityRequestEntity } from '../../model/api/identity-verification/idology-verify-identity-request.entity.interface';
import { IIdologyProgress } from '../../model/models/identity-verification/idology-progress-response.interface';
import { HttpProvider } from '../http/http';
import { RouteProvider } from '../../providers/route/route';

@Injectable()
export class IdentityVerificationProvider {
  constructor(private httpProvider : HttpProvider, private routeProvider: RouteProvider) { }

  verifyIdentityFromProfile(): Promise<IIdologyProgress> {
    return this.httpProvider
      .get(`${APP_CONFIG.remittanceApiBaseUrl}identification/verifyidentity`, {}, (res: IIdologyProgressResponseEntity) => {
        return IdentityVerificationMapper.fromIdologyResponseEntity(res)
      });
  }

  verifyIdentityFromTaxId(taxId: string): Promise<IIdologyProgress> {
    return this.httpProvider
      .put(`${APP_CONFIG.remittanceApiBaseUrl}identification/verifyidentity/${taxId}`, {}, (res: IIdologyProgressResponseEntity) => {
        return IdentityVerificationMapper.fromIdologyResponseEntity(res);
      });
  }

  verifyIdentityFromQuestionsAnswered(request: IIdologyVerifyIdentityRequestEntity): Promise<IIdologyProgress> {
    return this.httpProvider
      .post(`${APP_CONFIG.remittanceApiBaseUrl}identification/verifyidentity`, request, (res: IIdologyProgressResponseEntity) => {
        return IdentityVerificationMapper.fromIdologyResponseEntity(res)
      });
  }

  showIdologyVerifyPage(onFailed?: any, onSuccess?: any, onContinue?: any) { // also used by Trunarrative and Socure
    var identityPromise = null;
    const params = {
      identityPromise: identityPromise,
      onFailed: () => {
        if (onFailed)
          onFailed();
        else
          this.routeProvider.replace(this.routeProvider.pages.SendFailedPage);
      },
      onSuccess: () => {
        if (onSuccess)
          onSuccess();
        else
          this.routeProvider.replace(this.routeProvider.pages.SendFinishPage);
      },
      onContinue: () => {
        if (onContinue)
          onContinue();
        else
          this.routeProvider.replace(this.routeProvider.pages.SendFinishPage);
      },
      analyticsLocation: 'send-money'
    };
    this.routeProvider.replace(this.routeProvider.pages.SendVerifyPage, params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/identity-verification/identity-verification.ts